import Layout from "@/components/Layout";
import SEO from "@/components/SEO";
import { Eyebrow } from "@/components/ui-bits";
import { FIRM } from "@/data/firm";

export default function Contact() {
  return (
    <Layout>
      <SEO
        title="Contact"
        description={`Contact Shelton Law PLLC by email — ${FIRM.email} for general inquiries, ${FIRM.careersEmail} for attorney inquiries.`}
        path="/contact"
      />
      <section className="border-b border-hairline" data-testid="contact-hero">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 pt-20 pb-16">
          <Eyebrow>Contact</Eyebrow>
          <h1 className="display-1 text-ink mt-6 max-w-4xl">
            Get in touch.
          </h1>
          <p className="mt-8 text-ink-soft text-[1.0625rem] leading-relaxed max-w-2xl">
            Inquiries may be made by email. Messages are ordinarily returned within one business day. A brief description of the matter is helpful.
          </p>
        </div>
      </section>

      <section className="border-b border-hairline" data-testid="contact-body">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-24 grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-2 hidden lg:block">
            <div className="rule-brass w-12 mt-4" />
          </div>
          <div className="lg:col-span-10 grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-14">
            <ContactBlock label="General Inquiries">
              <a href={FIRM.emailHref} className="font-serif text-3xl text-ink hover:text-brass transition-colors block break-all" data-testid="contact-email">
                {FIRM.email}
              </a>
              <p className="text-sm text-ink-soft mt-3">Client inquiries, referrals, and press.</p>
            </ContactBlock>

            <ContactBlock label="Attorney Inquiries">
              <a href={FIRM.careersEmailHref} className="font-serif text-3xl text-ink hover:text-brass transition-colors block break-all" data-testid="contact-careers-email">
                {FIRM.careersEmail}
              </a>
              <p className="text-sm text-ink-soft mt-3">Confidential. See also the Careers page.</p>
            </ContactBlock>

            <ContactBlock label="Office Hours">
              <p className="font-serif text-2xl text-ink leading-snug">{FIRM.hours}</p>
              <p className="text-sm text-ink-soft mt-3">After-hours communications are reviewed the following business day.</p>
            </ContactBlock>
          </div>
        </div>
      </section>

      <section data-testid="contact-note">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 py-20 text-center">
          <Eyebrow>Notice</Eyebrow>
          <p className="mt-6 font-serif italic text-2xl text-ink-soft leading-snug">
            The transmission of information through this website, or by email, does not establish an attorney-client relationship. No attorney-client relationship is formed until the firm has agreed in writing to undertake representation.
          </p>
        </div>
      </section>
    </Layout>
  );
}

function ContactBlock({ label, children }) {
  return (
    <div className="border-t border-hairline pt-6">
      <p className="eyebrow mb-4">{label}</p>
      {children}
    </div>
  );
}
